import React from "react";
import { useLang } from '../contexts/LanguageContext';
import { Container } from "react-bootstrap";
import NavbarHome from '../components/NavbarIndex';
import Footer from "../components/Footer";




export default function Privacy() {
  // Traducciones
  const { t } = useLang();

  return (
    <div>
      <NavbarHome static_page="true" />
      <Container className="p-2">
        <h1>{t("PRIVACY_TITLE")}</h1>
        <p className="text-end">{t("PRIVACY_DATE_DESC")}</p>
        <p style={{ textAlign: "justify" }}>{t("PRIVACY_RESUME")}</p>
        <ol dangerouslySetInnerHTML={{ __html: t("PRIVACY_TEXT") }} />

      </Container>
      <Footer />
    </div>
  );
}